<template>
  <div class="a-checkbox u-margin-top-24">
    <category-settings :category="item"
                       @click="onCategoryClick"
                       v-for="(item, idx) in categories"
                       :key="idx"></category-settings>
  </div>
</template>

<script>
  import _ from 'lodash'
  import CategorySettings from './CategorySettings'

  export default {
    components: {
      CategorySettings
    },

    computed: {
      categories() {
        const categoriesSettings = this.$store.getters.categoriesSettings;

        return this.allCategories.map(e => {
          return {
            ...e,
            isMonitored: _.indexOf(categoriesSettings, e.id) > -1
          }
        });
      }
    },

    data: () => ({
      allCategories: []
    }),

    mounted() {
      this.runBlockerAction(async () => {
        try {
          this.allCategories = await this.$store.dispatch('searchCategories', { maxLevel: 2 });
        }
        catch(e) {
          console.error('unable to fetch list of categories', e);
          this.globalErrorHandler(e);
        }
      })
    },

    methods: {
      async onCategoryClick(category) {
        this.runBlockerAction(async () => {
          try {
            let categories;
            const idx = _.findIndex(this.allCategories, { id: category.id });
            let i = idx + 1;

            for (; i < this.allCategories.length; ++i) {
              if (this.allCategories[i].level <= category.level) {
                break;
              }
            }

            categories = this.allCategories.slice(idx, i);
            await this.$store.dispatch('updateCategorySetting', { categories, isMonitored: category.isMonitored });
          }
          catch(e) {
            console.error('unable to update category settings', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
